<script setup >
import { shallowRef } from 'vue';
import one from './components/one.vue';
import one52 from './components/one52.vue'
import one53 from './components/one53.vue'
import two from './components/two.vue';
import two52 from './components/two52.vue'
import two53 from './components/two53.vue'
import three from './components/three.vue';
import four from './components/four.vue';
import four52 from './components/four52.vue'
import defaultComp from './components/defaultComp.vue';
let steps = []

const currentQa = inject('provideCurrentQa');
if (currentQa.value.sonQueType == '51') { // 工资薪金题
  steps = [
    {key:'one',name:'1.收入及减除填写'},
    {key:'two',name:'2.税款计算'},
    {key:'three',name:'3.附表填写'},
    {key:'four',name:'4.申报表报送'}
  ]
} else if (currentQa.value.sonQueType == '52') { // 全年奖金题
  steps = [
    {key:'one52',name:'1.收入及减除填写'},
    {key:'two52',name:'2.税款计算'},
    {key:'three',name:'3.附表填写'},
    {key:'four52',name:'4.申报表报送'}
  ]
} else if (currentQa.value.sonQueType == '53') { // 劳务报酬题
  steps = [
    {key:'one53',name:'1.收入及减除填写'},
    {key:'two53',name:'2.税款计算'},
    {key:'three',name:'3.附表填写'},
    {key:'four52',name:'4.申报表报送'}
  ]
}

const showComp = shallowRef(defaultComp)
const activeKey = ref('')
const setActive = (item) =>{
    activeKey.value = item.key;
    switch (item.key) {
        case 'one':
            showComp.value = one
            break;
      case 'one52':
            showComp.value = one52
            break
      case 'one53':
            showComp.value = one53
            break
        case 'two':
            showComp.value = two
            break;
      case 'two52':
            showComp.value = two52
            break
      case 'two53':
            showComp.value = two53
            break
        case 'three':
            showComp.value = three
            break;
        case 'four':
            showComp.value = four
            break;
      case 'four52':
            showComp.value = four52
            break;
        case 'default':
            showComp.value = defaultComp
            break;
        default:
            break;
    }
}
const  changeTab = (key) =>{
    setActive({key})
}
</script>

<template>
    <div class="wrap">
        <ul class="steps">
            <li v-for="(item,index) in steps"  :key="index" @click="setActive(item)">
                <span :class="{ active: activeKey == item.key}" class="name">{{ item.name }}</span>
                <i v-if="item.key!='four'"> >> </i>
            </li>
        </ul>
        <div class="content">
            <component :is="showComp" @changeTab="changeTab"/>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.wrap{
    width:100%;
    height: 100%;
    .steps{
        width: 100%;
        display: flex;
        li{
            width: 25%;
            display: flex;
            align-items: center;
            height: 38px;
            .name{
                flex:1;
                height: 38px;
                background: #f0f3f6;
                font-size: 16px;
                color: #333;
                border-radius: 38px;
                line-height: 38px;
                border: 1px solid #e0e0e0;
                box-sizing: border-box;
                padding: 0 24px;
                cursor: pointer;
            }
            .name.active{
                background: #2c95e9;
                color: #fff;
                border: 1px solid #2c95e9;
            }
            i{
                width: 40px;
                text-align: center;
            }
        }
    }
    .content{
        width: 100%;
        height: calc(100% - 40px)
    }
}
</style>
